<template>
  <el-container class="ServicePrint">
    <el-main ref="print" class="p-0">
      <div>
        <table class="table-border--2 w-full">
          <tr>
            <td cell-padding="0">
              <div class="title">{{title}}</div>
              <div class="flex">
                <div class="flex-auto info align-center">
                  <span>{{contract_date}}</span>
                  <hr />
                  <span class="addr">{{data.destination}}</span>
                  <hr />
                  <span>아래와 같이 계산합니다.</span>
                </div>
                <div class="flex-fixed" style="width: 400px">
                  <table
                    class="supplier-table table-border__solid table-border--2 supplier-table align-center"
                  >
                    <col width="20" />
                    <col width="80" />
                    <col width="120" />
                    <col width="60" />
                    <col width="120" />
                    <tr>
                      <td rowspan="6">공 급 자</td>
                      <td>등록번호</td>
                      <td colspan="3">{{company.crn}}</td>
                    </tr>
                    <tr>
                      <td>상 호</td>
                      <td>{{company.name}}</td>
                      <td>성 명</td>
                      <td>{{company.owner}}</td>
                    </tr>
                    <tr>
                      <td>
                        사업장
                        <br />소재지
                      </td>
                      <td colspan="3">{{company.addr}}</td>
                    </tr>
                    <tr>
                      <td>업 태</td>
                      <td>{{company.conditions}}</td>
                      <td>종 목</td>
                      <td>{{company.item}}</td>
                    </tr>
                    <tr>
                      <td>대표전화</td>
                      <td colspan="3">{{company.tel}}</td>
                    </tr>
                    <tr>
                      <td>이메일</td>
                      <td colspan="3">{{company.email}}</td>
                    </tr>
                  </table>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <table class="detail-table bold table-border__solid w-full align-center">
                <col width="50px" />
                <col />
                <col width="40px" />
                <col width="40px" />
                <col width="40px" />
                <col width="80px" />
                <col width="80px" />
                <col width="60px" />
                <col />
                <tr>
                  <td>
                    합계
                    <BR />금액
                  </td>
                  <td colspan="8" class="price">
                    <span>일금 {{data.price | numberToKorean}}</span>
                    <span>￦{{data.price | number}}</span>
                    <span class="font-small">(VAT포함)</span>
                  </td>
                </tr>
                <tr>
                  <th>날짜</th>
                  <th>품목</th>
                  <th>규격</th>
                  <th>수량</th>
                  <th>단위</th>
                  <th>단가</th>
                  <th>공급가액</th>
                  <th>세액</th>
                  <th>비고사항</th>
                </tr>
                <tr v-for="d in details" v-bind:key="d.id">
                  <td>{{resolveDate(d)}}</td>
                  <td class="align-left pl-default">{{d.product_name}}</td>
                  <td>{{d.size}}</td>
                  <td>{{d.amount}}</td>
                  <td>{{d.unit_name}}</td>
                  <td class-name="cell-number">{{d.supply_price | number}}</td>
                  <td class-name="cell-number">{{d.price | number}}</td>
                  <td class-name="cell-number">{{d.tax | number}}</td>
                  <td>&nbsp;</td>
                </tr>
                <tr>
                  <th colspan="3">합계금액</th>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td class-name="cell-number">{{data.price | number}}</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                </tr>
                <tr class="desc-row">
                  <td>비고</td>
                  <td colspan="8" class="align-left pl-default">{{company.bank}} 예금주 {{company.name}}</td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
        <div class="right">
          <img :src="siteLogoPath" height="42" />
        </div>
      </div>
    </el-main>
    <el-footer>
      <el-button
        type="primary"
        v-shortkey="['f8']"
        @shortkey.native="clickPrint"
        @click="clickPrint"
      >인 쇄 (F8)</el-button>
      <el-button @click="closeDialog" class="right">{{$t('button.close')}} (Esc)</el-button>
    </el-footer>
  </el-container>
</template>
<script>
import Vue from "vue";
import { company_info } from "@/common/mixins/company_info";
import Print from "@/plugins/print/print";

Vue.use(Print);

export default {
  name: "ServicePrint",
  mixins: [company_info],
  data() {
    return {
      service_date: this.util.getDate(),
    }
  },
  props: {
    title: {
      type: String,
      required: true
    },
    data: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  computed: {
    details() {
      let items = Object.assign([], this.data.details);
      if (items.length < 6) {
        for (let i = items.length; i < 6; i++) {
          items.push({});
        }
      }
      return items;
    },
    contract_date() {
      return this.data.id? this.data.contract_date : "";
    }
  },
  mounted() {
    this.loadConfig();
  },
  methods: {
    resolveDate(data) {
      if (data.id) {
        return data.service_date = this.service_date.substring(5,7) + "/" + this.service_date.substring(8,10);
      }
    },
    /** 출력 */
    clickPrint() {
      this.$print(this.$refs.print);
    },
    /** 닫기 */
    closeDialog() {
      this.$emit("completed");
    }
  }
};
</script>

<style lang="scss">
.ServicePrint {
  .title {
    height: 60px;
    line-height: 60px;
    background-color: #eee;
    font-size: 20px;
    font-weight: bold;
    text-align: center;
  }
  .info {
    padding-top: 20px;
    font-size: 1.2em;
    hr {
      width: 300px;
    }
    span {
      display: block;
      width: 250px;
      min-height: 30px;
      margin: auto;
    }
    .addr {
      font-weight: bold;
    }
  }
  .supplier-table {
    tr {
      height: 24px;
    }
  }
  .price {
    span:not(:last-child) {
      padding-right: 20px;
    }
  }
  .detail-table {
    tr {
      height: 30px;
    }
  }
  .desc-row {
    border-top-style: double;
  }
}
</style>
